import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'

import api from '../services/api'
import { paramsToObject, validarCPF } from '../utils/functions'
import { mCPF, mTel } from '../utils/masks'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function RegVendedores() {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [data, setData] = useState({})
  const [erroCpf, setErroCpf] = useState(false)
  const [updateType, setUpdateType] = useState(false)
  const [erroEmail, setErroEmail] = useState(false)


  useEffect(() => {

    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      console.log(query.codigo)
      if (query.codigo) {
        setUpdateType(true)
        api.get('/vendedores?pk_pve=' + query.codigo).then(r => {
          console.log(query.codigo)
          if (Object.values(r.data).slice(0, -1)[0]) {
            console.log(Object.values(r.data).slice(0, -1)[0][0])
            setData(Object.values(r.data).slice(0, -1)[0][0])

            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'EMAIL',
      'NOME',
      'CPF',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)

      if (erroEmail && (errors.indexOf('EMAIL') === -1)) errors.push('EMAIL')

    })

    return errors
  }

  async function handleCpf(e) {
    e.preventDefault();
    if (!validarCPF(e.target.value) && (String(e.target.value) !== '')) {
      switch (e.target.name) {
        case 'CPF': setErroCpf(true)
      }
      swal.fire('CPF inválido', 'Informe um CPF válido!', 'warning')
    } else {
      switch (e.target.name) {
        case 'CPF':
          setErroCpf(false)
          if (String(e.target.value) !== '') {
            await api.get('propostas?cpf_existente=' + e.target.value).then(r => {
              if (r.data.length > 0) {
                setErroCpf(true)
                swal.fire('CPF inválido', 'Já existe proposta ativa para este CPF!', 'warning')
              }
            })
          }
          break
      }
    }
  }


  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        auxValues.pk_uex = auth.user
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/vendedores/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/vendedores/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    // auxValues[e.target.name] = e.target.value;
    switch (e.target.name) {
      case 'CPF':
        auxValues[e.target.name] = mCPF(e.target.value)
        break

      case 'FONE':
        auxValues[e.target.name] = mTel(e.target.value)
        break

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  function handleEmail(e) {
    e.preventDefault();
    if (e.target.value) {
      if (e.target.value.indexOf('@') === -1) {
        setErroEmail(true)
        swal.fire('Email inválido', 'Informe um email válido!', 'warning')
      } else setErroEmail(false)
    }
  }

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h1>{updateType ? 'Edição' : 'Inclusão'} de Vendedor</h1>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          <FrTextInput
            maxLength='150'
            value={data.NOME || ''}
            onChange={handleChange}
            name="NOME"
            id="NOME"
            color="#F1873B"
            label="Nome"
            variant="outlined"
            size="small"
            style={{ width: 500 }}
          />
          <FrTextInput
            maxLength='45'
            value={data.EMAIL || ''}
            onChange={handleChange}
            onBlur={handleEmail}
            name="EMAIL"
            id="EMAIL"
            color="#F1873B"
            label="E-mail"
            variant="outlined"
            size="small"
            required
            style={{ width: 500 }}
          />

          <FrTextInput
            error={erroCpf}
            maxLength='14'
            value={data.CPF || ''}
            onChange={handleChange}
            onBlur={handleCpf}
            name="CPF"
            id="CPF"
            color="#F1873B"
            label="CPF"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
          <FrTextInput
            maxLength='45'
            value={data.FONE || ''}
            onChange={handleChange}
            name="FONE"
            id="FONE"
            color="#F1873B"
            label="Telefone"
            variant="outlined"
            size="small"
            style={{ width: 160 }}
          />
          <FrSelect 
            value={data.ATIVO || []} 
            style={{ width: 100 }} 
            name="ATIVO" 
            id="ATIVO" 
            label='Ativo' 
            data={[{value: 'S', display: 'Sim'}, {value: 'N', display: 'Não'}]}
            onChange={handleChange}
          />    
        </form>
        <div className="regButtonsDiv">
          <button onClick={handleSubmit}>Salvar</button>
          <button onClick={handleCancel}>Cancelar</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegVendedores;
